import { FormsModule } from '@angular/forms';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { AnnouncementsService } from './announcements.service';
import { MglTimelineModule } from 'angular-mgl-timeline';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MglTimelineModule,
    WsgSharedModule
  ],
  declarations: [
    AnnouncementsComponent
  ],
  providers: [
    AnnouncementsService
  ],
  exports: [
    AnnouncementsComponent
  ]
})
export class AnnouncementsModule { }
